import React from "react";
import { useI18n } from "@/context/I18nContext";

export function PageHeader({ title, subtitle, actions }) {
  const { t } = useI18n();
  return (
    <div className="flex items-start justify-between gap-4 mb-6 animate-fade-in">
      <div>
        <h1 className="text-2xl md:text-3xl font-medium tracking-tight text-[#0A0A0A]">{t(title)}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{t(subtitle)}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
